import { Validator } from "..";

export const requiredValidator =
  <T>(): Validator<T | undefined | null, T, "required"> =>
  (input) => {
    if (!input) return { failure: "required", successful: false };
    return { value: input, successful: true };
  };
